// extracted by mini-css-extract-plugin
module.exports = {"item":"creatableItem_item__3gkUO","icon":"creatableItem_icon__yI6Oq"};